export default __webpack_public_path__ + "static/media/gradient-arrow-narrow-right.d99eafd9.svg";